const { genMultilineRegexp } = require('./common');
const { CUSTOMER_TYPE } = require('./enum');

exports.isValidPhoneNumber = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  return /(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/.test(value);
};

exports.isValidEmail = (string) => {
  if (typeof string === 'undefined' || string === null || string === '') {
    return true;
  }

  const emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  return emailRegExp.test(string);
};

exports.isValidTaxNo = (taxNo) => {
  if (typeof taxNo === 'undefined' || taxNo === null || taxNo === '') {
    return true;
  }

  const hasTenNumber = /^[0-9]{10}$/.test(taxNo);
  const hasCombineWithDashThreeNumber = /^\d{10}-\d{3}$/.test(taxNo);
  // Hộ kinh doanh / cá nhân dùng số CCCD 12 số làm MST (TT 86/2024/TT-BTC)
  const isIdCardTaxNo = exports.ID_CARD.REGEX_CCCD.test(taxNo);

  return hasTenNumber || hasCombineWithDashThreeNumber || isIdCardTaxNo;
};

// Khách Bán buôn/Đại lý được nhập MST vào ô SĐT, chỉ dạng 10 số hoặc 10 số-3 số
exports.isTaxCodeOfB2BCustomer = (value, customerType) =>
  [CUSTOMER_TYPE.WHOLESALE_CUSTOMER, CUSTOMER_TYPE.AGENCY].includes(
    Number(customerType),
  ) &&
  typeof value === 'string' &&
  /^\d{10}(-\d{3})?$/.test(value.trim());

exports.isNullishObject = (obj) => {
  if (!obj) return true;

  return Object.values(obj).every((value) =>
    [null, undefined, ''].includes(value),
  );
};

exports.isObject = (target) => {
  return target
    ? Object.prototype.toString.call(target) === '[object Object]'
    : false;
};

exports.isEmptyObject = (target) => {
  if (!this.isObject(target)) return false;
  return target && Object.keys(target).length;
};
exports.hasSpecialCharacters = (string) => {
  if (typeof string === 'undefined' || string === null || string === '') {
    return null;
  }

  const regexSpecialCharacters = /[\s~`!@#$%^&*+=[\]\\';,/{}|\\":<>?()._]/g;
  const normalizedString = string.normalize().trim();
  return !regexSpecialCharacters.test(normalizedString);
};

exports.checkAscent = (string) => {
  if (!string || !string.trim()) return '';

  const regexAscent = genMultilineRegexp(
    [
      'à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ',
      'è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ',
      'ì|í|ị|ỉ|ĩ',
      'ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ',
      'ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ',
      'ỳ|ý|ỵ|ỷ|ỹ',
      'đ',
    ],
    'g',
  );

  return regexAscent.test(string);
};

exports.MAX_LENGTH_VAT_CODE = 12;
exports.MAX_LENGTH_VAT_SERIAL = 12;

exports.ID_CARD = Object.freeze({
  CCCD_LENGTH: 12,
  REGEX_CCCD: /^\d{12}$/,
});

/**
 * @name isValidIdCard
 * @description Validate CCCD (12 chữ số). Cho phép null/undefined/empty (optional field).
 * @param {string|null|undefined} value
 * @returns {boolean}
 */
exports.isValidIdCard = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  return exports.ID_CARD.REGEX_CCCD.test(value);
};

/**
 * @name isTruthyString
 * @description Check if value is of type string and is truthy.
 *
 * @param {String} value
 * @return {Boolean | void}
 */
exports.isTruthyString = (value) => {
  if (typeof value !== 'string') {
    console.error('Value is not of type string');
    return;
  }

  return Boolean(value.length);
};

/**
 * @param {String[]} values
 * @return {boolean}
 */
exports.areTruthyStrings = (values) => {
  for (const value of values) {
    if (!this.isTruthyString(value)) {
      return false;
    }
  }
  return true;
};

/**
 * @name hasCustomerNameAppellationPrefix
 * @description
 * Check tên khách hàng có bắt đầu bằng đại từ xưng hô hay không
 * (Anh / Chị / Em / Cô / Chú)
 *
 * LƯU Ý:
 * - Không phân biệt hoa thường
 * - Bắt buộc có khoảng trắng phía sau
 *   => tránh false case tên thật: "Anh", "Em"
 *
 * @param {String} value
 * @return {Boolean}
 */
exports.hasCustomerNameAppellationPrefix = (value) => {
  if (typeof value !== 'string' || !value.trim()) {
    return false;
  }

  const normalized = value.trim().toLowerCase();

  const appellations = ['anh', 'chị', 'em', 'cô', 'chú'];

  return appellations.some((prefix) => normalized.startsWith(prefix + ' '));
};

exports.CUSTOMER_NAME_APPELLATION_WARNING_MESSAGE =
  'Họ và tên khách hàng không bao gồm đại từ xưng hô (Anh/Chị/Em/Cô/Chú)';
